import type React from "react";

import { Trash2 } from "lucide-react";

import { ConfirmationModal } from "@/components/confirmation-modal";

interface BulkDeleteModalProps {
  isLoading?: boolean;
  isOpen: boolean;
  onConfirm: () => void;
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
  selectedCount: number;
}

export function BulkDeleteModal({
  isLoading = false,
  isOpen,
  onConfirm,
  onOpenChange,
  selectedCount,
}: BulkDeleteModalProps) {
  return (
    <ConfirmationModal
      cancelButtonText="Cancel"
      confirmButtonColor="destructive"
      confirmButtonText={isLoading ? "Deleting..." : "Delete"}
      icon={<Trash2 className="text-featured-icon-light-fg-error" />}
      isConfirmLoading={isLoading}
      isOpen={isOpen}
      onConfirm={onConfirm}
      onOpenChange={onOpenChange}
      text={
        <>
          <p className="text-sm text-text-tertiary">
            Are you sure you want to delete {selectedCount} draft request
            {selectedCount === 1 ? "" : "s"}?
          </p>
          <p className="text-sm text-text-tertiary">
            This action will move the request{selectedCount === 1 ? "" : "s"} to
            trash and cannot be undone.
          </p>
        </>
      }
      title={`Delete ${selectedCount} Draft${selectedCount === 1 ? "" : "s"}`}
    />
  );
}
